import { Map } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Commentable } from '@/shared/comments/Commentable';

/**
 * fork(oem): the catch-all scene.
 *
 * In this proof of concept it is reached far more often as a *roadmap* state
 * than as a broken link: every Tier 2 route in `shared/oem-nav.ts` resolves
 * here until its scene lands, and the assistant can navigate into one. So the
 * copy is "on the roadmap", not "couldn't find that page", and the way out is
 * Asset360 and Fleet health rather than the foundation's orphaned Projects
 * module.
 *
 * UI layer (layer 4 of the 4-layer architecture).
 */
export function NotFoundScene() {
  return (
    <Commentable name="NotFoundScene">
      <main className="flex min-h-dvh flex-col items-center justify-center bg-[var(--background)] px-6 py-16 text-center text-zinc-900 dark:text-zinc-100">
        <div
          aria-hidden
          className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl border border-[var(--glass-border)] bg-accent-50/60 text-accent-700 dark:bg-[color-mix(in_srgb,var(--color-accent-500)_14%,transparent)] dark:text-accent-400"
        >
          <Map className="h-6 w-6" strokeWidth={1.6} />
        </div>

        <h1 className="text-4xl tracking-tight text-zinc-900 dark:text-zinc-100">
          Not built yet
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-muted">
          This surface is on the roadmap for the next pass. The operating model
          behind it is in the data already — the screen is what is still to come.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex h-9 items-center justify-center rounded-full bg-accent-600 px-5 text-sm font-medium text-white transition-colors hover:bg-accent-700"
          >
            Back to Asset360
          </Link>
          <Link
            to="/fleet"
            className="inline-flex h-9 items-center justify-center rounded-full border border-[var(--glass-border)] bg-white/60 px-5 text-sm font-medium text-zinc-700 transition-colors hover:border-[var(--glass-border-strong)] hover:bg-white/90 dark:bg-zinc-900/40 dark:text-zinc-300"
          >
            Fleet health
          </Link>
        </div>
      </main>
    </Commentable>
  );
}
